import React, { useState } from 'react';
import Input, { Props as InputProps } from 'components/atoms/Input';

export interface Props extends InputProps {
  onChangeHandler?: (type: any, value: string) => void;
  thousandSeparator?: boolean;
}

function InputOnlyNumber({
  inputName,
  maxLength = 11,
  thousandSeparator = false,
  onChangeHandler,
  ...props
}: Props): React.ReactElement {
  const [number, setNumber] = useState<string>('');
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    const formatNum = thousandSeparator
      ? Number(value.replace(/\D+/g, '')).toLocaleString()
      : value.replace(/\D+/g, '');
    if (formatNum.length <= maxLength) {
      if (onChangeHandler) {
        onChangeHandler(name, formatNum);
      }
      setNumber(formatNum);
    }
  };

  return (
    <Input
      inputName={inputName}
      type={'tel'}
      value={number}
      onChange={onChange}
      {...props}
    />
  );
}

export default InputOnlyNumber;
